export default __webpack_public_path__ + "static/media/04.268421cd.png";